const arr = [{
  path: 'charts1',
  name: 'charts1',
  component: resolve => {
    require(['../view/chart/chart1.vue'], resolve)
  },
  meta:{
    keepAlive:false
  }
},
  {
    path: 'charts2',
    name: 'charts2',
    component: resolve => {
      require(['../view/chart/chart2.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts3',
    name: 'charts3',
    component: resolve => {
      require(['../view/chart/chart3.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts4',
    name: 'charts4',
    component: resolve => {
      require(['../view/chart/chart4.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts5',
    name: 'charts5',
    component: resolve => {
      require(['../view/chart/chart5.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts6',
    name: 'charts6',
    component: resolve => {
      require(['../view/chart/chart6.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts7',
    name: 'charts7',
    component: resolve => {
      require(['../view/chart/chart7.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts8',
    name: 'charts8',
    component: resolve => {
      require(['../view/chart/chart8.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts9',
    name: 'charts9',
    component: resolve => {
      require(['../view/chart/chart9.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts10',
    name: 'charts10',
    component: resolve => {
      require(['../view/chart/chart10.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts11',
    name: 'charts11',
    component: resolve => {
      require(['../view/chart/chart11.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts13',
    name: 'charts13',
    component: resolve => {
      require(['../view/chart/chart13.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts12',
    name: 'charts12',
    component: resolve => {
      require(['../view/chart/chart12.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts14',
    name: 'charts14',
    component: resolve => {
      require(['../view/chart/chart14.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts15',
    name: 'charts15',
    component: resolve => {
      require(['../view/chart/chart15.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'charts16',
    name: 'charts16',
    component: resolve => {
      require(['../view/chart/chart16.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  },
  {
    path: 'aaa',
    name: 'aaa',
    component: resolve => {
      require(['../view/chart/aaa.vue'], resolve)
    },
    meta:{
      keepAlive:false
    }
  }
]

export default arr;



// WEBPACK FOOTER //
// ./src/router/chart.js